var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container page"},[_c('iframe',{attrs:{"width":"100%","height":"100%","src":this.$store.getters.getBaseInfo.kefu !==undefined ?this.$store.getters.getBaseInfo.kefu:'https://hao.360.com/'}})])}
var staticRenderFns = []

export { render, staticRenderFns }